export const creator_X2AQOJ8B = {
  integrations: {
    fb_pixel: {
      FB_PIXEL_IDS: ["3457805604442242"],
    },
  },
};
